module.exports = __webpack_public_path__ + "media/images/top/icon/white/ico_person-29cdeeb83034320b7d7efa8a6e58cf19.svg";